import { render } from "./EditorSwitchRow.vue?vue&type=template&id=3bf6427b&scoped=true"
import script from "./EditorSwitchRow.vue?vue&type=script&lang=js"
export * from "./EditorSwitchRow.vue?vue&type=script&lang=js"

import "./EditorSwitchRow.vue?vue&type=style&index=0&id=3bf6427b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf6427b"]])

export default __exports__